import React, { useState, Fragment } from 'react';
import ExtraMapLineFeatures from './ExtraMapLineFeatures'
import ExtraMapMarkerFeatures from './ExtraMapMarkerFeatures'
import ExtraMapLayers from './ExtraMapLayers'

/**
 * Displays feature definitions on the map: 
 * - first (re-) creating the layers
 * - then adding geojson lines
 * - then adding markers
 */
export default function ExtraMapFeatures(props)  {
  
  if (EXTRA_MAP_FEATURES_DISABLED) return ;

  return (
    <>
      <ExtraMapLayers  
          location={location} browserHistory={props.history}
          initialSubview={props.initialSubview}
      />
      <ExtraMapLineFeatures  
          location={location} browserHistory={props.history}
          initialSubview={props.initialSubview}
      />
      <ExtraMapMarkerFeatures  
          location={location} browserHistory={props.history}
          initialSubview={props.initialSubview}
      />      
    </>
  )

}
